




import { Component, Vue } from "vue-property-decorator";

import OperatnBaseMenu, { MenuItem } from '@/components/gears/bases/OperatnBaseMenu.vue';

@Component({
  components: {
    OperatnBaseMenu
  }
})
export default class MenuControlloAlloggi extends Vue {
  /* DATA */

  private items: MenuItem[] = [
    {
      icon: "mdi-account",
      text: "Ospiti",
      path: "/controllo-alloggi/ospiti",
    },
    {
      icon: "mdi-bed",
      text: "Ricerca Stanze",
      path: "/controllo-alloggi/ricerca-stanze",
    },
    {
      icon: "mdi-bed",
      text: "Controlli",
      path: "/controllo-alloggi/controlli",
    },
    {
      icon: "mdi-table-large",
      text: "Tabellone",
      path: "/controllo-alloggi/tabellone",
    },
  ];
}
